export default {
  path: '/premium',
  name: 'premium.index',
  redirect: { name: 'premium.subscription' },
  component: () =>
    import(/* webpackChunkName: "premium" */ '@/views/premium/index.vue'),
  children: [
    {
      path: '/premium/subscription',
      name: 'premium.subscription',
      component: () =>
        import(
          /* webpackChunkName: "subscription" */ '@/views/premium/Subscription.vue'
        )
    },
    {
      path: '/premium/subscribe',
      name: 'premium.subscribe',
      component: () =>
        import(
          /* webpackChunkName: "subscribe" */ '@/views/premium/Subscribe.vue'
        )
    }
  ]
}
